/**
 * Debug logging utility
 *
 * Set VITE_DEBUG_LOGGING=true in .env to enable verbose debug logs.
 * Debug logging is disabled by default, even in development mode.
 */

const DEBUG_ENABLED = import.meta.env.VITE_DEBUG_LOGGING === "true";

/**
 * Log a debug message (only when VITE_DEBUG_LOGGING=true)
 */
export function debugLog(prefix: string, ...args: unknown[]): void {
  if (DEBUG_ENABLED) {
    console.log(`[${prefix}]`, ...args);
  }
}

/**
 * Log a debug warning (only when VITE_DEBUG_LOGGING=true)
 */
export function debugWarn(prefix: string, ...args: unknown[]): void {
  if (DEBUG_ENABLED) {
    console.warn(`[${prefix}]`, ...args);
  }
}

/**
 * Log a debug error (always logs - errors should always be visible)
 */
export function debugError(prefix: string, ...args: unknown[]): void {
  console.error(`[${prefix}]`, ...args);
}

/**
 * Check if debug logging is enabled
 */
export function isDebugEnabled(): boolean {
  return DEBUG_ENABLED;
}
